import { Spin } from "antd"
import { Loader as LoaderIcon } from "lucide-react"

import useGlobalStore from "~/store/global"

export default function Loader({
  className = "",
  style
}: {
  className?: string
  style?: React.CSSProperties
}) {
  return (
    <Spin
      indicator={
        <LoaderIcon
          className={`animate-spin text-primary dark:text-dark-6 ${className}`}
          style={{ fontSize: 32, ...style }}
        />
      }
      size="default"
    />
  )
}

export function OSLoader({
  className = "",
  style
}: {
  className?: string
  style?: React.CSSProperties
}) {
  const appTheme = useGlobalStore((store) => store.appTheme)
  return (
    <div
      className={`os-loader ${
        appTheme === "dark" ? "os-loader-dark" : ""
      } ${className}`}
      style={style}
    />
  )
}

export function DotLoader({
  className = "",
  style,
  size = "small"
}: {
  className?: string
  style?: React.CSSProperties
  size?: "xSmall" | "small" | "medium" | "large"
}) {
  const sizeMap = {
    xSmall: "h-2 w-2",
    small: "h-3 w-3",
    medium: "h-4 w-4",
    large: "h-6 w-6"
  }
  const loaderClassName = `${sizeMap[size]} bg-black rounded-full motion-safe:animate-bounce`
  return (
    <div
      className={`flex space-x-2 justify-center items-center bg-transparent dark:invert ${className}`}
      style={style}
    >
      <div className={`${loaderClassName} [animation-delay:-0.3s]`} />
      <div className={`${loaderClassName} [animation-delay:-0.15s]`} />
      <div className={`${loaderClassName} motion-safe:animate-bounce`} />
    </div>
  )
}
